// extracted by mini-css-extract-plugin
export default {"jiraAttachmentLinkPopover":"JrPr83ae56b3dAt6GwfQ","jiraAttachmentLinkPopoverContainer":"ReG6RuWGzs0RAjLIXo3C","jiraAttachmentLink":"io99VTkGM6x0ysISwJ_k"};